@if (isProcessingCallback) {
<div class="login-right glass-effect callback-loading">
  <mat-spinner diameter="48"></mat-spinner>
  <h3>Connexion en cours…</h3>
</div>

} @else if (mfaRequired) {
<div class="login-right glass-effect">
  <h2>Vérification en deux étapes</h2>
  <h3 *ngIf="mfaMethod === 'totp'">Entrez le code affiché dans votre application authenticator (Google Authenticator,
    Authy…)</h3>
  <h3 *ngIf="mfaMethod !== 'totp'">Un code a été envoyé à votre adresse email.</h3>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Code de vérification</mat-label>
    <input matInput type="text" [(ngModel)]="mfaCode" name="mfaCode" placeholder="000000" maxlength="6"
      inputmode="numeric" autocomplete="one-time-code" [disabled]="savingMfa || mfaTimeLeft === 0" />
    <mat-icon class="material-symbols-outlined" matSuffix>verified</mat-icon>
  </mat-form-field>

  <div class="mfa-timer" [class.expired]="mfaTimeLeft === 0">
    <mat-icon>schedule</mat-icon>
    <span *ngIf="mfaTimeLeft > 0">Code valide pendant {{ mfaTimeLeft }}s</span>
    <span *ngIf="mfaTimeLeft === 0">Code expiré</span>
  </div>

  <p class="mfa-error" *ngIf="mfaError">{{ mfaError }}</p>

  <lib-button color="primary" text="Valider" class="button" size="large"
    [disabled]="mfaCode.length !== 6 || mfaTimeLeft === 0 || savingMfa" [loading]="savingMfa" (click)="submitMfaCode()">
  </lib-button>

  <a mat-button (click)="cancelMfa()" class="back-link">← Retour à la connexion</a>
</div>

} @else {
<div class="login-right glass-effect">
  <h2>Bienvenue !</h2>

  <h3>Connectez-vous pour utiliser Unifield</h3>

  <form (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      
      <input matInput type="email" class="input-form" [(ngModel)]="email" name="email" placeholder="Email"
        data-testid="login-email" required />

      <mat-icon class="material-symbols-outlined" matSuffix>mail</mat-icon>
      <mat-hint>*Ce champ est obligatoire.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>

      <input matInput class="input-form" type="password" [(ngModel)]="password" name="password"
        placeholder="Mot de passe" data-testid="login-password" required />

      <mat-icon class="material-symbols-outlined" matSuffix>lock</mat-icon>
      <mat-hint>*Ce champ est obligatoire.</mat-hint>
    </mat-form-field>

    <lib-button color="primary" text="Se connecter" type="submit" class="button" size="large"
      data-testid="login-btn"></lib-button>
  </form>

  <div class="form-option">
    <mat-checkbox [(ngModel)]="remember" name="remember" class="remember">
      Se souvenir de moi
    </mat-checkbox>

    <div class="routes">
      <a mat-button [routerLink]="['/auth/forgot-password']">Mot de passe oublié</a> -
      <a mat-button [routerLink]="['contact-us']">Pas encore de compte ?</a>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="sso-login">
    <p class="sso-error" *ngIf="ssoError">
      {{ ssoError }}
    </p>

    <button mat-stroked-button (click)="redirectToMicrosoft()">
      <span class="btn-span">
        <img src="img/logo/logo_microsoft.png" alt="Microsoft Logo" />
        Se connecter avec Microsoft
      </span>
    </button>

    <button mat-stroked-button (click)="redirectToGoogle()">
      <span class="btn-span">
        <img src="img/logo/logo_google.svg" alt="Google Logo" />
        Se connecter avec Google
      </span>
    </button>
  </div>

</div>
}